export const scoreValidation = (scoreValue) => {
  let regex =/^[0-9]*$/;
  return regex.test(scoreValue);
};
